import React, { useState, useMemo, useCallback } from "react";
import WidgetConfigurationContext from "data-lake/preview/contexts/WidgetConfigurationContext";
import createInitialWidget from "data-lake/preview/storage-types/internal/createInitialWidget";
const WidgetConfigurationProvider = ({ initialSearch, children = null }) => {
  const [widget, setWidget] = useState(() => createInitialWidget(initialSearch));
  const resetWidget = useCallback(() => {
    setWidget(createInitialWidget());
  }, []);
  const contextValue = useMemo(
    () => ({
      widget,
      setWidget,
      isLoading: false,
      resetWidget
    }),
    [resetWidget, widget]
  );
  return /* @__PURE__ */ React.createElement(WidgetConfigurationContext.Provider, { value: contextValue }, children);
};
export default WidgetConfigurationProvider;
